export const USERROLES = {
    SUPERADMIN: 'SYS_ADMIN',
    HOST: 'HOST',
    COMPLIANCE: 'CMP_OFFICER',
    GUEST: 'GUEST'
}